module.exports = __webpack_public_path__ + "img/geogateway2.9eb854fe.png";